import { render, staticRenderFns } from "./ChannelStatistics.vue?vue&type=template&id=594118c6"
import script from "./ChannelStatistics.vue?vue&type=script&lang=js"
export * from "./ChannelStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports